//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Cookies from '@/plugin/cookies.js'
export default {
  name: 'Container',
  data () {
    return {
      defaultActive: '',
      username: ''
    }
  },
  methods: {
    logout: function () {
      this.$confirm('确认退出?', '提示',
        { cancelButtonClass: 'btn-custom-cancel' })
        .then(() => {
          sessionStorage.removeItem('user')
          Cookies.clearCookie('un')
          Cookies.clearCookie('upwds')
          this.$router.push('/login')
        })
        .catch(() => { })
    },
    modifypassword: function () {
      this.$router.push('/modifypassword')
    },
    handleOpen (key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      console.log(key, keyPath)
    },
    handleSelect (key, keyPath) {
      console.log(key, keyPath)
    }
  },
  mounted: function () {
    let user = sessionStorage.getItem('user')
    if (user) {
      this.username = user
    }
  }
}



// WEBPACK FOOTER //
// ./src/container/Container.vue